var exports = {
  "m": "withMinimalCard__WciLkr",
};

module.exports = exports;
